import isInIframe from '@anm/helpers/is/isInIframe';
import { isSemrushIframe } from '@anm/helpers/semrush';
import { isEqual } from 'lodash';
import React, { memo, FC } from 'react';
import { BrokenVideoStatusCodes, PlayerBlockProps, VideoStatusCode } from '../../types';
import BrokenPlayer from '../BrokenPlayer';
import VideoPlayer, { VideoPlayerProps } from '../Player';
import ProtectedVideo from '../ProtectedVideo';
import VideoInProcess from '../VideoInProcess';

const MemoizedPlayer = memo(VideoPlayer, (prev: VideoPlayerProps, next: VideoPlayerProps) => isEqual(prev, next));

const PlayerBlock: FC<PlayerBlockProps> = props => {
  const { isEmbedded } = props.videoData || {};

  const isVideoData = !!props.videoData;

  const isCustomization = props.target === 'customization';
  const notEmbeddedInIframe = isInIframe() && !isEmbedded && !isCustomization && !isSemrushIframe();
  const notEmbeddedInPopover = props.isPopover && !isEmbedded;
  const isVideoPrivate = (notEmbeddedInIframe || notEmbeddedInPopover) && isVideoData;

  const canShowInProcessPlayer = props.errorCode === VideoStatusCode.in_process && isVideoData;
  const canShowProtectedPlayer = props.errorCode === VideoStatusCode.protected;
  const canShowBrokenPlayer =
    !!props.errorCode && props.errorCode !== VideoStatusCode.in_process && props.errorCode !== VideoStatusCode.no_video;

  const canRenderPlayer = props.stream
    ? !!props.stream && isVideoData && !props.isPending
    : isVideoData && !props.isPending;

  switch (true) {
    case canShowInProcessPlayer:
      return <VideoInProcess {...props} videoData={props.videoData!} />;

    case canShowProtectedPlayer:
      return <ProtectedVideo {...props} />;

    case canShowBrokenPlayer:
      return <BrokenPlayer {...props} errorCode={props.errorCode as BrokenVideoStatusCodes} />;

    case isVideoPrivate:
      return <BrokenPlayer {...props} errorCode={VideoStatusCode.private} />;

    default:
      return canRenderPlayer ? (
        <MemoizedPlayer {...props} videoData={props.videoData!} {...{ isCustomization }} />
      ) : null;
  }
};

export default PlayerBlock;
